var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 18.8561C14.6022 18.8561 18.3332 15.1252 18.3332 10.5228C18.3332 5.92041 14.6022 2.18945 9.99984 2.18945C5.39746 2.18945 1.6665 5.92041 1.6665 10.5228C1.6665 15.1252 5.39746 18.8561 9.99984 18.8561Z",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9165 7.9939C7.9165 7.59616 7.9165 7.39729 7.99962 7.28627C8.07206 7.18952 8.18293 7.12898 8.30349 7.12037C8.44182 7.11049 8.60911 7.21803 8.94368 7.43311L12.8775 9.962C13.1678 10.1486 13.313 10.242 13.3631 10.3606C13.4069 10.4643 13.4069 10.5813 13.3631 10.685C13.313 10.8036 13.1678 10.8969 12.8775 11.0836L8.94368 13.6125C8.60911 13.8275 8.44182 13.9351 8.30349 13.9252C8.18293 13.9166 8.07206 13.8561 7.99962 13.7593C7.9165 13.6483 7.9165 13.4494 7.9165 13.0517V7.9939Z",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.acb6396fb45f738fdfbb39a8a4acdfa2.svg";
export { ForwardRef as ReactComponent };